import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-[15px] font-bold leading-5 transition-colors disabled:pointer-events-none disabled:border-line disabled:bg-sunken disabled:text-ink-muted [&_svg]:pointer-events-none [&_svg]:size-5 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // One primary (marker yellow) button per view.
        default: "bg-marker text-on-marker hover:bg-marker-hover",
        // Solid danger: only inside the dialog that confirms a deletion.
        destructive: "bg-sev-high text-surface hover:opacity-90",
        danger: "border border-sev-high bg-transparent text-sev-high hover:bg-sev-high-soft",
        outline: "border border-line-strong bg-surface text-ink hover:bg-sunken",
        secondary: "bg-sunken text-ink hover:bg-line",
        ghost: "text-ink hover:bg-sunken",
        link: "h-auto px-0 text-ink underline decoration-marker decoration-2 underline-offset-[3px]",
      },
      size: {
        default: "h-11 px-5",
        sm: "h-9 px-3 text-sm",
        lg: "h-[52px] px-7 text-[17px]",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
